/**
 * @file 个人中心
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Table, Tag, Tips} from '@baidu/spui';
import {fetchGetPaidAttestList, fetchFeedbackDetail} from '../../../actions/userCenterAction';
import {fetchDelete} from '../../../actions/attestAction';
import {
    // bCat_2055_request,
    recordProxy
} from '../../../util';
import './style.less';
class myAttestPaidList extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            page: 1,
            size: 10,
            total: 10,
            data: [],
            selectedKeys: [],
            pageObj: {
                my_attest: {
                    text: '付费认证',
                    type: 'auth'
                }
            }
        };
    }
    componentDidMount() {
        // const paramsType = this.props.match.params.type;
        this.getList();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.type !== this.props.match.params.type) {
            this.setState({
                data: []
            }, () => {
                // const paramsType = this.props.match.params.type;
                this.getList();
            });

        }
        if (nextProps.myAttestData.paidAttestList !== this.props.myAttestData.paidAttestList) {
            this.setState({
                data: nextProps.myAttestData.paidAttestList.result || [],
                total: nextProps.myAttestData.paidAttestList.total
            });

        }
    }

    getList = () => {
        let {page, size} = this.state;
        this.props.fetchGetPaidAttestList({
            page: page,
            size: size
        });
        // 付费认证有权限控制，暂定不走bCat_2055_request【临时注释】
        // const fetchGetPaidAttestList = params => {
        //     this.props
        //         .fetchGetPaidAttestList(pageObj[type].type, {
        //             page: page,
        //             size: size,
        //             ...params
        //         });
        // };
        // bCat_2055_request(fetchGetPaidAttestList);
    };

    render() {
        // const data = this.props.myAttestData.paidAttestList;
        if (!this.state.data.length) {
            return null;
        }
        let type = this.props.match.params.type;
        let {pageObj, page, size, total, data} = this.state;

        let columnConfigs = [
            {
                refer: 'id',
                title: '认证ID',
                width: '100px'
            },
            {
                refer: 'company_name',
                title: '企业名称',
                width: '180px',
                render: (val, index, row) => {
                    return (
                        <span>
                            {val}
                            {row.is_history ? (
                                // val
                                <Tips
                                    title="该认证信息已在2021年3月底开启产品全面升级调整，建议您重新认证！"
                                    placement={'right'}
                                >
                                    <img
                                        className="uptip"
                                        src={require('../../../asset/img/upgrade/error.svg')}
                                        alt=""
                                    />
                                </Tips>
                            ) : null}
                        </span>
                    );
                }
            },
            {
                refer: 'phone',
                title: '认证号码',
                width: '150px',
                render: (val) => {
                    return (
                        <>
                            {val?.split(',')?.map((item, index) =>
                                <p key={item + index}>{item}</p>
                            )}
                        </>
                    );
                }
            },
            {
                refer: 'person_status',
                title: '审核状态',
                width: '110px',
                render: val => {
                    let obj = {
                        '待审核': {
                            color: 'blue',
                            // title: '待审核'
                        },
                        '审核成功': {
                            color: 'green',
                            // title: '审核通过'
                        },
                        '审核失败': {
                            color: 'red',
                            // title: '审核失败'
                        },
                        '付费完成': {
                            color: 'green',
                            // title: '已过期'
                        },
                        '待续费': {
                            color: 'blue',
                            // title: '已过期'
                        }
                    };
                    return <Tag title={val} type={'hollow'} color={obj[val].color} />;
                }
            },
            {
                refer: 'update_time',
                title: '更新时间',
                width: '125px',
                render: val => {
                    return val.split(' ')[0];
                }
            },
            {
                refer: 'expired_time',
                title: '过期时间',
                width: '125px',
                render: val => {
                    return val.split(' ')[0];
                }
            },
            {
                refer: 'd6',
                title: '操作',
                width: '180px',
                render: (val, index, data) => {
                    return (
                        <div className={'operate attestcz'}>
                            <a
                                href={`/user_center/my_attest?companyName=${data.company_name}`}
                                className={'link'}
                                target={'_blank'}
                                rel="noopener noreferrer"
                                onClick={() => recordProxy('my-attest', 'click', 'my-attest-report')}
                            >
                                查看详细报告
                            </a>
                        </div>
                    );
                }
            }
        ];

        const pageConfigs = {
            skipFlag: true,
            current: page,
            perPage: size,
            totalItem: total || 10,
            onChange: data => {
                this.setState(
                    {
                        page: data.current,
                        size: data.perPage
                    },
                    () => {
                        this.getList();
                    }
                );
            }
        };
        return (
            <div className={'paidAttest'}>
                <div className={'top'}>
                    <div className={'title'}>{pageObj[type].text}</div>
                </div>
                <div className={'con'}>
                    <Table data={data} columnConfigs={columnConfigs} pager={pageConfigs} />
                </div>
            </div>
        );
    }
}

myAttestPaidList.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    fetchGetPaidAttestList: PropTypes.func,
    fetchFeedbackDetail: PropTypes.func,
    fetchDelete: PropTypes.func,
    myAttestData: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        myAttestData: state.myAttestReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchGetPaidAttestList: (type, obj) => fetchGetPaidAttestList(dispatch, type, obj),
        fetchFeedbackDetail: obj => fetchFeedbackDetail(dispatch, obj),
        fetchDelete: obj => fetchDelete(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(myAttestPaidList));
